import React from 'react'
import Icon from 'src/components/common/Icon';
import { NotFoundMessage } from './Results404.styles';

export const Results404 = ({ message }: { message?: string }) => {
    return (
        <NotFoundMessage>
            <Icon disableFill icon="pcom-icon-warning-outline" size={64} />
            {message ?? "No se encontraron resultados para esta sección"}
        </NotFoundMessage>
    )
}
